import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import InSectionThree from '../../components/InSectionThree'

const ecommerceServices = [
   {
      title: 'Omnichannel Commerce',
      image: '/assets/svg/industries/Ecommerce/01.ecomm.svg',
      description:
         'We design frictionless omnichannel commerce experiences that merge online and offline shopping into a single seamless customer experience with consistent interactions across various touchpoints. With updated real-time inventory, personalized offers, and effortless checkout, we assist you in increasing customer interaction, driving revenue, and increasing brand loyalty.',
   },
   {
      title: 'Electronics & Digital Goods eCommerce',
      image: '/assets/svg/industries/Ecommerce/02Electronics.svg',
      description:
         'Our electronic eCommerce platforms provide safe transactions, live stock updates, and live product catalogs. Through AI-based suggestions and easy checkout processes, we enable enterprises to improve customer interactions, optimize processes, and increase online revenues for digital offerings and consumer electronics.',
   },
   {
      title: 'Mobile-First eCommerce (mCommerce)',
      image: '/assets/svg/industries/Ecommerce/03.Mobileecomm.svg',
      description:
         'We create mobile-first eCommerce sites with super-speedy performance, simple UX, and secure payments. Our solutions encompass mobile wallets, push notifications, and location-based offers, enabling you to connect mobile shoppers better, drive more conversions, and provide a seamless purchase experience.',
   },
   {
      title: 'B2B eCommerce Solutions',
      image: '/assets/svg/industries/Ecommerce/04.B2B.svg',
      description:
         'Our B2B eCommerce sites simplify bulk transactions, automate business processes, and optimize buyer-supplier dynamics. With price customization models, invoice automation, and ERP integration, we assist companies in enhancing efficiency, streamlining operations, and accelerating revenue growth.',
   },
   {
      title: 'B2C Online Store Development',
      image: '/assets/svg/industries/Ecommerce/05.B2C.svg',
      description:
         'We create B2C eCommerce sites featuring AI-driven suggestions, custom offers, and frictionless checkout processes. With multi-channel support and secure payments, we help businesses drive sales, enhance customer satisfaction, and build lasting brand loyalty.',
   },
   {
      title: 'Enterprise-Grade Marketplace Solutions',
      image: '/assets/svg/industries/Ecommerce/06.Enterprise.svg',
      description:
         'We construct multi-vendor marketplaces that scale with automated seller management, real-time pricing, and live analytics. Our solutions streamline operations, improve customer experiences, and fuel revenue increases by enabling frictionless transactions and effective vendor management.',
   },
];
 
function EcommerceSectionThree() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Innovative eCommerce Solutions for Various Sectors
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               We build bespoke eCommerce platforms specific to various industries, merging advanced technology with ease of use to provide next-generation shopping experiences. Our scalable and flexible solutions enable businesses to excel in the dynamic digital economy.
            </p>
         </div>
         <div className="position-relative">
            <InSectionThree itemData={ecommerceServices} />
         </div>
      </section>
   )
}

export default EcommerceSectionThree
